import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8079b62e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "如需购买意机损保险，请添加设备后前往“极飞服务小程序-应用-极加服务”购买。", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  fill: "none",
  version: "1.1",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("g", null, [
    /*#__PURE__*/_createElementVNode("g", null, [
      /*#__PURE__*/_createElementVNode("g", null, [
        /*#__PURE__*/_createElementVNode("path", {
          d: "M9.557844375,8.00016609375L5.073036375,12.48499609375C4.941030375,12.61699609375,4.873803075,12.68469609375,4.849605375,12.76099609375C4.828777395,12.82669609375,4.828777385,12.89749609375,4.849605275,12.96319609375C4.873802775,13.03949609375,4.941031375,13.10719609375,5.073036375,13.23919609375L5.261598375,13.42779609375C5.393604375,13.55979609375,5.461366375,13.62699609375,5.537647375,13.65119609375C5.603305375,13.67199609375,5.674139375,13.67199609375,5.739797375,13.65119609375C5.816078375,13.62699609375,5.883844375,13.55979609375,6.015844375,13.42779609375L10.972054374999999,8.471566093749999C11.232404375,8.21121609375,11.232404375,7.78910609375,10.972054374999999,7.52875609375L6.015844375,2.57254809375C5.883844375,2.44054309375,5.816077375,2.37331479375,5.739797375,2.34911709375C5.674139375,2.32828910375,5.603305375,2.32828910375,5.537647375,2.34911709375C5.461367375,2.37331479375,5.393604375,2.44054309375,5.261598375,2.57254909375L5.073037375,2.76111009375C4.941031375,2.89311609375,4.873803275,2.96087809375,4.849605475,3.03715909375C4.828777535,3.10281709375,4.828777535,3.17365109375,4.849605475,3.23930909375C4.873803275,3.31558909375,4.941031375,3.38335609375,5.073037375,3.51535609375L9.557844375,8.00016609375Z",
          "fill-rule": "evenodd",
          fill: "#000000",
          "fill-opacity": "0.5600000023841858"
        })
      ])
    ])
  ])
], -1))
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]
const _hoisted_4 = { class: "content-wrap" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "请使用手机微信扫描二维码访问", -1))
const _hoisted_6 = { class: "qrcode-wrap" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button van-hairline--top" }, "我知道了", -1))

import { ref } from 'vue'
import { Overlay } from 'vant'
import { usePlatformInfo } from '@/compositions/common'
import Qrcode from '@chenfengyuan/vue-qrcode'


export default /*#__PURE__*/_defineComponent({
  __name: 'jijia-introduce-src4-tips',
  setup(__props) {

const { isSrc4Device } = usePlatformInfo()
const modalShow = ref(false)
const code_url = ref('https://s.xa.com/mini?k=aBheXX')

function showMiniProgram() {
  modalShow.value = true
}
function overlayClickHandle() {
  modalShow.value = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(isSrc4Device))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "src-tips",
          onClick: showMiniProgram
        }, _hoisted_3))
      : _createCommentVNode("", true),
    _createVNode(_unref(Overlay), {
      show: modalShow.value,
      onClick: overlayClickHandle
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(Qrcode), {
                value: code_url.value,
                options: {
              width: 160,
              margin: 1,
            }
              }, null, 8, ["value"])
            ])
          ]),
          _hoisted_7
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})